<template>
  <div class="dropdown" style="float:left;">
    <button class="dropbtn attendance-dropdown" @mouseover="displayContent = true">
      <p>
        <span v-if="location">{{ locations[location] }}</span>
        <span v-else>Location</span>&nbsp;<i class="fas fa-caret-down"></i>
      </p>
    </button>
    <div class="dropdown-content" v-if="displayContent">
      <a href="#" @click.prevent="filter(null)" @click="displayContent = false">All</a>
      <a href="#" v-for="(value, index) in locations" :key="index" @click.prevent="filter(index)" @click="displayContent = false">{{ value }}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LocationFilter',
    props: {
      location: {
        default: null
      }
    },
    data() {
      return {
        locations: {},
        displayContent: false,
      };
    },
    mounted() {
      this.axios.get(`/locations`)
        .then(response => {
          let rooms = {};

          response.data.locations.forEach(location => rooms[location.id] = location.name);
          this.$set(this, 'locations', rooms);
        });
    },
    methods: {
      filter(value) {
        this.$emit('location', value);
      }
    }
  }
</script>
